<template>
  <NuxtLink
    :to="toLocalePath(linkTo)"
    class="flex"
    :title="$t('header.logo_title')"
    data-test-id="logo-link"
  >
    <svg
      class="h-[29px] w-[137px] origin-left transition-all xl:h-[56px] xl:w-[260px]"
      :class="{
        'my-1 xl:my-0 xl:scale-50': size == 'sm',
      }"
      version="1.1"
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 623.62 113.39"
      xml:space="preserve"
    >
      <title>{{ $t('header.logo_title') }}</title>
      <g>
        <path
          class="st0"
          d="M275.23,110.33h-14.22L261,56.67c0,0,0.44-0.04,1.18-0.04c4.4,0,19.62,1.5,21.35,22.11h2.07   c-0.54-6.84-0.82-14.76-0.82-22.89c0-8.09,0.28-15.98,0.81-22.81h-2.07c-1.48,19.11-17.04,20.46-21.39,20.46   c-0.71,0-1.12-0.04-1.12-0.04L261,3.06h19.05c12.68,0,16.64,19.71,17.39,24.34h2.15L299.62,0h-58.69v3.06h5.67v107.27h-5.67v3.06   h63.34l0.01-31.62h-2.19C299.84,100.72,290.8,110.33,275.23,110.33"
        />
        <path
          class="st0"
          d="M411.67,110.33h-14.22l-0.01-53.66c0,0,0.43-0.04,1.18-0.04c4.4,0,19.62,1.5,21.35,22.11h2.07   c-0.54-6.84-0.82-14.76-0.82-22.89c0-8.09,0.28-15.98,0.81-22.81h-2.07c-1.48,19.11-17.04,20.46-21.39,20.46   c-0.71,0-1.12-0.04-1.12-0.04l-0.01-50.4h19.05c12.68,0,16.64,19.71,17.39,24.34h2.15L436.06,0h-58.69v3.06h5.67v107.27h-5.67v3.06   h63.34l0.02-31.62h-2.19C436.28,100.72,427.24,110.33,411.67,110.33"
        />
        <path
          class="st0"
          d="M621.43,81.77c-2.26,18.95-11.3,28.56-26.86,28.56h-14.22l-0.01-53.66c0,0,0.43-0.04,1.18-0.04   c4.39,0,19.62,1.5,21.35,22.11h2.07c-0.54-6.84-0.82-14.76-0.82-22.89c0-8.09,0.28-15.98,0.81-22.81h-2.07   c-1.48,19.11-17.04,20.46-21.39,20.46c-0.71,0-1.12-0.04-1.12-0.04l-0.01-50.4h19.05c12.68,0,16.64,19.71,17.39,24.34h2.15   L618.95,0h-58.69v3.06h5.67v107.27h-5.67v3.06h63.34l0.01-31.62H621.43z"
        />
        <path
          class="st0"
          d="M216.01,8.09C206.65,0.79,196.19,0,192.14,0v0h-19.28c-4.19,0-7.74,0-8.98,0v3.06h5.66v107.27h-5.66v3.06   h27.27c37.31,0,42.87-35.8,42.87-57.14C234.01,33.6,227.96,17.4,216.01,8.09 M192.13,110.33L192.13,110.33l-8.16,0V3.06h8.15   c8.64,0.07,15.17,4.48,19.39,13.13c4.28,8.75,6.54,22.01,6.7,39.4C218.47,92.42,210.43,109.3,192.13,110.33"
        />
        <polygon
          class="st0"
          points="43.7,85.34 19.92,0 0,0 0,3.06 5.67,3.06 5.67,110.33 0,110.33 0,113.39 14.61,113.39 14.61,110.33    8.94,110.33 8.94,12.13 37.36,113.39 39.81,113.39 65.94,14.14 65.93,110.33 60.26,110.33 60.26,113.39 86.05,113.39 86.05,110.33    80.38,110.33 80.38,3.06 86.05,3.06 86.05,0 66.2,0  "
        />
        <polygon
          class="st0"
          points="448.95,3.06 454.57,3.06 454.54,110.33 448.95,110.33 448.95,113.39 474.08,113.39 474.08,110.33    468.48,110.33 468.48,3.06 474.1,3.06 474.1,0 448.95,0  "
        />
        <path
          class="st0"
          d="M344.47,110.33h-11.91V3.06h5.67V0h-25.75v3.06h5.67v107.27h-5.67v3.06h61.03l0.02-31.62h-2.19   C369.07,100.72,360.03,110.33,344.47,110.33"
        />
        <path
          class="st0"
          d="M124.98,0h-2.61L92.87,110.33h-4l0.01,3.06h10.79v-3.06h-3.48l8.58-32.28h27.17l8.68,32.28h-4.39v3.06h25.13   v-3.06h-5.91L124.98,0z M105.47,74.99l12.71-48.13l12.94,48.13H105.47z"
        />
        <polygon
          class="st0"
          points="537.02,0 537.02,3.06 542.69,3.06 542.69,77.36 505.01,0 483.79,0 483.79,3.06 489.46,3.06    489.46,110.33 483.79,110.33 483.79,113.38 498.39,113.38 498.39,110.33 492.72,110.33 492.72,10 543.35,113.39 545.96,113.39    545.96,3.06 551.62,3.06 551.58,0  "
        />
      </g>
    </svg>
  </NuxtLink>
</template>

<script setup lang="ts">
import useRouteHelpers from '#layers/base/composables/useRouteHelpers'

type LogoProps = {
  linkTo?: string
  size?: 'sm' | 'md'
}

withDefaults(defineProps<LogoProps>(), {
  linkTo: '/',
  size: 'md',
})
const { toLocalePath } = useRouteHelpers()
</script>

<style lang="scss" scoped>
.st0 {
  fill: #222;
}
</style>
